module.exports = __webpack_public_path__ + "media/images/athletes/1568-0ba60938acba69743ad2e88d51764bcd.png";